"use client";

import { useCallback } from "react";
import {
    type CarouselApi,
    CarouselContent,
    CarouselItem,
} from "~/components/ui/carousel";
import Carousel from "~/componentsDS/Carousel";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import { useTrackEvent } from "~/hooks/useTrackEvent";
import { RESULTS } from "./data";
import ResultCard from "./ResultCard";

function shouldWatchCarouselDrag(_api: unknown, event: MouseEvent | TouchEvent) {
    const target = event.target;

    if (!(target instanceof Element)) {
        return true;
    }

    return !target.closest(".cursor-ew-resize");
}

export default function ResultsCarousel() {
    const sendEvent = useTrackEvent();

    const handleSelect = useCallback((api: CarouselApi) => {
        if (!api) return;

        const result = RESULTS[api.selectedScrollSnap()];
        if (!result) return;

        sendEvent({
            event: "user_interaction",
            value: {
                event_name: GTM_EVENT_NAMES.HP_INTERACTION,
                widget: "improvement_results",
                meta_data: {
                    image_person_name: result.name,
                    product_name: "anti-aging face cream",
                },
            },
        });
    }, [sendEvent]);

    return (
        <div className="-mx-6 mt-6 overflow-hidden md:-mx-12 lg:mx-0 lg:mt-8 lg:overflow-visible">
            <Carousel
                loop={true}
                variant="compact"
                arrows={false}
                compactPaginationAlign="right12"
                compactPaginationBg="bg-pureWhite/10 backdrop-blur-[25px]"
                compactPaginationDotColor="bg-gray100"
                controlsClassName="lg:hidden"
                onSelect={handleSelect}
                opts={{
                    align: "start",
                    watchDrag: shouldWatchCarouselDrag,
                    breakpoints: {
                        "(min-width: 1024px)": {
                            active: false,
                        },
                    },
                }}
                className="lg:[&>div:first-child]:overflow-visible"
            >
                <CarouselContent className="ml-4 md:ml-10 lg:!grid lg:!transform-none lg:grid-cols-3 lg:gap-4 lg:ml-0">
                    {RESULTS.map((result) => (
                        <CarouselItem
                            key={`${result.name}-${result.age}`}
                            className="basis-[calc(100%-2.5rem)] pl-2 md:basis-[calc(100%-5.5rem)] lg:!transform-none lg:basis-auto lg:pl-0"
                        >
                            <ResultCard result={result} />
                        </CarouselItem>
                    ))}
                </CarouselContent>
            </Carousel>
        </div>
    );
}
